import Swiper from 'swiper/bundle';

export function testimonialCarousel() {
	const els = document.querySelectorAll('.testimonial-carousel.swiper');
	if (!els.length) return;

	els.forEach((el) => {
		const wrapper = el.querySelector('.swiper-wrapper');

		function setFixedHeight() {
			// Reset so slides can measure naturally
			wrapper.style.height = '';
			const slides = el.querySelectorAll('.swiper-slide');
			let max = 0;
			slides.forEach((slide) => {
				slide.style.height = 'auto';
				max = Math.max(max, slide.scrollHeight);
			});
			slides.forEach((slide) => {
				slide.style.height = max + 'px';
			});
			wrapper.style.height = max + 'px';
		}

		new Swiper(el, {
			loop: true,
			autoplay: {
				delay: 6000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			effect: 'fade',
			fadeEffect: { crossFade: true },
			autoHeight: false,
			pagination: {
				el: el.querySelector('.testimonial-carousel__pagination'),
				clickable: true,
			},
			on: {
				init: setFixedHeight,
			},
		});

		window.addEventListener('resize', setFixedHeight);
	});
}
